


<!-- 
<div class= "test">
    <FloatingWindow class="test" v-if="zoomBool == false" :dockButton="false" :closeButton="false" docked="true" title="Bitte zoomen Sie näher heran, um Objekte der ausgewählten POI Layer sehen zu können.">
    </FloatingWindow>
</div> -->

